import { QueryClientProvider } from "@tanstack/react-query"
import { MemoryRouter } from "react-router-dom"
import { StyleProvider } from "@ant-design/cssinjs"
import { ConfigProvider } from "antd"
import { queryClient } from "api/queryClient"
import { resolveViewerSearch } from "components/ui/customWebviewer/core/popOutWindow.helpers"

type Props = { shadowRoot: ShadowRoot; children: React.ReactNode }

export const ShadowDomProviders = ({ shadowRoot, children }: Props) => (
	<QueryClientProvider client={queryClient}>
		{/* The MemoryRouter is seeded ONCE per shadow root, and these roots are created lazily — a
		    fresh one on every panel open (see the orchestrator's `render()` notes). So the seed must
		    not read `window.location.search` directly: inside the pop-out window that query is
		    stripped after boot (#1430, requirement 2), and every sidebar seeded afterwards resolved
		    `Number(null) === 0` and addressed its saves to `/quotations/0/…` — reads worked, every
		    write 500'd, and nothing surfaced it. `resolveViewerSearch()` returns the live search
		    everywhere except the pop-out route, where it falls back to that window's stored ids. */}
		<MemoryRouter initialEntries={[window.location.pathname + resolveViewerSearch()]}>
			<StyleProvider container={shadowRoot}>
				{/* Brand blue (--clr-main) for AntD's active/focus state so the right sidebar's form
				    controls match our custom keyboard-focus ring. colorPrimary is otherwise unset app-wide,
				    so AntD would fall back to its default #1677ff and clash with the #0047FF ring. */}
				<ConfigProvider theme={{ token: { colorPrimary: "#0047FF" } }}>{children}</ConfigProvider>
			</StyleProvider>
		</MemoryRouter>
	</QueryClientProvider>
)
